import React, { useRef } from 'react';
import styled from 'styled-components';
import { OpenButton } from './OpenButton';
import FritidBroker from './FritidBroker';

//GraphQL
import { useLazyQuery } from '@apollo/client';
import { GET_PAGE_AREA_BROKERS } from '../../../../../client/__graphql__/queries/page/getPageAreaBrokers';
import {
  GetPageMapAreaBrokersQuery,
  GetPageMapAreaBrokersQueryVariables,
  Maybe,
  Office,
  SingleBroker
} from '../../../../__types__/generated';

export interface IAreaItem {
  id: number;
  name: string;
  selected: boolean;
}

export interface IArgs {
  urlTag: string;
  area: IAreaItem;
}

export const AreaRowItem: React.FC<IArgs> = ({ area, urlTag }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const [getBrokers, { data: brokers, loading: brokerLoading }] = useLazyQuery<
    GetPageMapAreaBrokersQuery,
    GetPageMapAreaBrokersQueryVariables
  >(GET_PAGE_AREA_BROKERS, {
    onCompleted: ({ getPageMapAreaBrokers }) => {}
  });

  const onClick = async () => {
    if (!isOpen) {
      getBrokers({
        variables: { input: { pageUrlTag: urlTag, areaId: area?.id } }
      });
      setTimeout(() => {
        setIsOpen(!isOpen);
      }, 100);
    } else {
      setIsOpen(!isOpen);
    }
  };

  const getOfficeName = (offices?: Maybe<Office>[] | null) => {
    if (offices && offices?.length > 0) {
      const data = offices?.find((e: Maybe<Office>) => {
        return e?.name && e?.name?.length > 0;
      });
      if (data && data?.name) {
        return data?.name;
      }
    }
    return undefined;
  };

  return (
    <>
      <AreaRow
        onClick={() => {
          onClick();
        }}
      >
        <div className="area-name">{area?.name}</div>
        <OpenButton
          width={25}
          height={25}
          className="button"
          isPositive={!isOpen}
        />
      </AreaRow>
      <BrokersView className={isOpen ? 'open' : ''}>
        {!(
          !brokerLoading &&
          brokers?.getPageMapAreaBrokers?.count &&
          brokers?.getPageMapAreaBrokers?.list
        ) ? null : (
          <BrokerGrid count={brokers?.getPageMapAreaBrokers?.count}>
            {brokers?.getPageMapAreaBrokers?.list?.map(
              (broker: SingleBroker, index: number) => {
                return (
                  <FritidBroker
                    key={`broker-info-${index}`}
                    urltag={broker?.path ? `megler${broker?.path}` : undefined}
                    name={broker?.name ? broker?.name : ''}
                    email={broker?.email ? broker?.email : undefined}
                    officeName={
                      broker?.offices?.list
                        ? getOfficeName(broker?.offices?.list)
                        : undefined
                    }
                    phoneNumber={
                      broker?.cellphone ? broker?.cellphone : undefined
                    }
                    titles={broker?.title ? broker?.title : undefined}
                  />
                );
              }
            )}
          </BrokerGrid>
        )}
      </BrokersView>
    </>
  );
};

const AreaRow = styled.div`
  width: 100%;
  color: white;
  font-size: 22px;
  cursor: pointer;
  display: flex;
  position: relative;
  padding: 0.5em 0;
  align-items: center;
  .button {
    position: absolute;
    right: 0;
    display: flex;
    //padding-top: 4px;
    //height: 29px;
  }
  border-bottom: 1px #4b4b4b solid;
  .area-name {
    @media all and (max-width: 450px) {
      max-width: 250px;
      word-break: break-word;
    }
  }
`;

const BrokersView = styled.div`
  max-height: 0px;
  opacity: 0;
  transition: opacity 1s ease-in-out, max-height 0.8s ease-in-out;
  overflow: hidden;

  &.open {
    max-height: 5000px;
    opacity: 1;
  }
`;

const BrokerGrid = styled.div<{ count?: number }>`
  width: 100%;
  padding: 0em 1em;
  justify-content: center;
  overflow: hidden;
  padding-top: 2em;

  display: grid;
  grid-template-columns: minmax(120px, 180px);
  grid-column-gap: 4em;
  grid-row-gap: 1em;

  @media all and (min-width: 800px) {
    grid-template-columns: repeat(
      ${(p) => (p.count && p.count < 2 ? p.count : 2)},
      minmax(120px, 180px)
    );
  }
  @media all and (min-width: 1000px) {
    grid-template-columns: repeat(
      ${(p) => (p.count && p.count < 3 ? p.count : 3)},
      minmax(120px, 180px)
    );
  }
  @media all and (min-width: 1200px) {
    grid-template-columns: repeat(
      ${(p) => (p.count && p.count < 4 ? p.count : 4)},
      minmax(120px, 180px)
    );
  }
`;
